import { LitElement, html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';

import '@amityeko/design-system/dist/providers/notification';

import '../../components/top-achievement-list';

import '../view-recognitions-on-profile';
import type RnRPageViewRecognitionsOnProfile from '../view-recognitions-on-profile';

@customElement('rnr-page-top-achievement-list')
export default class RnRPageTopAchevementList extends LitElement {
  @query('#view_recognition_on_profile_page')
  viewRecognitionOnProfilePage!: RnRPageViewRecognitionsOnProfile;

  @property({ type: Number, attribute: 'limit' })
  limit: number = 3;

  @property({ attribute: 'receiver-id' })
  receiverId?: string;

  @property({ type: Number, attribute: 'preview-scale' })
  previewScale?: number;

  @property({ type: Boolean, attribute: 'should-show-header' })
  shouldShowHeader: boolean = true;

  private _onSelectCard(e: CustomEvent) {
    this.viewRecognitionOnProfilePage.onSelectCard(e);
  }

  private _onSelectViewAll() {
    this.viewRecognitionOnProfilePage.showViewRecognition();
  }

  protected render() {
    if (!this.receiverId) return null;

    return html`
      <amityeko-notification-provider>
        <rnr-top-achievement-list
          .limit=${this.limit}
          .receiverId=${this.receiverId}
          ?shouldShowHeader=${this.shouldShowHeader}
          @rnr-top-achievement-select-card=${this._onSelectCard}
          @rnr-select-view-all=${this._onSelectViewAll}
        ></rnr-top-achievement-list>

        <!-- TODO: We must not use page inside the page -->
        <rnr-page-view-recognitions-on-profile
          id="view_recognition_on_profile_page"
          .receiverId=${this.receiverId}
          .previewScale=${this.previewScale}
          ?shouldHideButton=${true}
        ></rnr-page-view-recognitions-on-profile>
      </amityeko-notification-provider>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-page-top-achievement-list': RnRPageTopAchevementList;
  }
}
